export default "__VITE_ASSET__CRJbdOuY__"